import { render, staticRenderFns } from "./tabVesselsPdf.vue?vue&type=template&id=c08d9a1a&scoped=true"
import script from "./tabVesselsPdf.vue?vue&type=script&lang=js"
export * from "./tabVesselsPdf.vue?vue&type=script&lang=js"
import style0 from "./tabVesselsPdf.vue?vue&type=style&index=0&id=c08d9a1a&prod&lang=scss"
import style1 from "./tabVesselsPdf.vue?vue&type=style&index=1&id=c08d9a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d9a1a",
  null
  
)

export default component.exports